#import "./ImageFull.graphql"

fragment OrderProductOptionsFull on OrderProductOptions {
  numbers {
    id
    number
  }
  extraFruit
  glutenFree
  lactoseFree
  meringues
  creamColor
  labels {
    id
    text
    status
  }
  lyingPhoto {
    id
    file {
      ...ImageFull
    }
    url
    status
  }
  standingPhotos {
    id
    file {
      ...ImageFull
    }
    url
    status
  }
  macaroons {
    chocolate
    lemon
    pistachio
    raspberry
    saltedCaramel
  }
  figurines {
    id
    description
    price
    status
  }
}
